import React, { useState, useEffect, useMemo } from 'react';
import { Flex, Text, useDisclosure } from '@chakra-ui/react';

import { IssuerStatItem, IssuerStatSortField, IssuerStatTable } from '../../Components/statistic/IssuerStatTable';
import { StatisticActionBar } from '../../Components/statistic/StatisticActionBar';
import { SimpleModal } from '../../Components/Common/Modal';
import { getIssuers, downloadStatistic } from '../../Utils/backStageApi';
import { checkAuth } from '../../Utils/common';

const StatisticPage: React.FC = () => {
  const [textFilter, setTextFilter] = useState<string>('');
  const [issuers, setIssuers] = useState<IssuerStatItem[]>([]);
  const [sortField, setSortField] = useState<IssuerStatSortField>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const { isOpen, onOpen, onClose } = useDisclosure();

  const downloadCsv = () => {
    downloadStatistic().then((response) => {
      if (response.headers['content-type']?.startsWith('text/csv')) {
        const blob = new Blob(['\uFEFF' + response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = 'certificate_statistic.csv';
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        onOpen();
      }
    });
  };

  useEffect(() => {
    checkAuth();
    getIssuers().then((data) => {
      if (!data?.list) return;
      setIssuers(data.list);
    });
  }, []);

  const handleSortToggle = (field: Exclude<IssuerStatSortField, null>) => {
    if (sortField === field) {
      setSortDirection((p) => (p === 'desc' ? 'asc' : 'desc'));
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };

  const filtered = useMemo(() => {
    const q = textFilter.trim();
    const f = issuers.filter((i) => i.name.includes(q) || i.cert_name.includes(q));

    if (!sortField) return f;

    return [...f].sort((a, b) => {
      const diff = a[sortField] - b[sortField];
      return sortDirection === 'desc' ? -diff : diff;
    });
  }, [issuers, textFilter, sortField, sortDirection]);

  return (
    <Flex w="100%" direction="column" align="center" pt="50px" pb="100px">
      <Text
        fontFamily="'Open Sans', sans-serif"
        fontSize="30px"
        fontWeight={600}
        lineHeight="133%"
        letterSpacing="0.01em"
        color="#000000"
        textAlign="center"
      >
        統計數據
      </Text>

      <StatisticActionBar mt="50px" searchText={textFilter} onSearchChange={setTextFilter} onDownload={downloadCsv} />

      <IssuerStatTable
        mt="22px"
        issuers={filtered}
        sortField={sortField}
        sortDirection={sortDirection}
        onSortToggle={handleSortToggle}
      />

      <SimpleModal
        isOpen={isOpen}
        onClose={onClose}
        header={<Text textStyle="semibold_lg">下載失敗！詳情請聯絡開發人員！</Text>}
      />
    </Flex>
  );
};

export default StatisticPage;
